import ScheduleApi from '@web/api/modules/Schedule'
import { SchedulePayload } from '@web/mapper/ScheduleMapper'
import {
  ScheduleActionsTree,
  ScheduleGettersTree,
  ScheduleMutationsTree,
  ScheduleState
} from '@web/store/types/modules/schedule'

const state: ScheduleState = {
  schedules: [],
  isLoaded: false
}

const getters: ScheduleGettersTree = {
  schedules: ({ schedules }) => schedules,
  getScheduleById: ({ schedules }) => (id: number) => schedules.find(schedule => schedule.id === id),
  isLoaded: ({ isLoaded }) => isLoaded
}

const mutations: ScheduleMutationsTree = {
  setSchedules (state, { schedules }) {
    state.schedules = schedules
  },
  addSchedule (state, schedule) {
    state.schedules.push(schedule)
  },
  updateSchedule (state, schedule) {
    const index = state.schedules.findIndex(({ id }) => id === schedule.id)
    if (index !== -1) {
      state.schedules.splice(index, 1, schedule)
    }
  },
  setScheduleEnabled (state, { id, isEnabled }) {
    const schedule = state.schedules.find(schedule => schedule.id === id)
    if (schedule) {
      schedule.isEnabled = isEnabled
    }
  },
  removeSchedule (state, id) {
    state.schedules = state.schedules.filter(schedule => schedule.id !== id)
  },
  setLoadStatus (state, status: boolean) {
    state.isLoaded = status
  },
  logout (state) {
    state.schedules = []
    state.isLoaded = false
  }
}

/* istanbul ignore next */
const actions: ScheduleActionsTree = {
  fetch ({ commit }) {
    return ScheduleApi.fetch()
      .then(({ data: schedules }) => {
        commit('setSchedules', { schedules })
        return schedules
      })
      .finally(() => {
        commit('setLoadStatus', true)
      })
  },
  fetchCached ({ dispatch, state }) {
    if (state.isLoaded) {
      return Promise.resolve(state.schedules)
    }
    return dispatch('fetch')
  },
  create ({ commit }, payload: SchedulePayload) {
    return ScheduleApi.create(payload)
      .then(({ data: schedule }) => {
        commit('addSchedule', schedule)
        return schedule
      })
  },
  update ({ commit }, { id, payload }: { id: number; payload: SchedulePayload }) {
    return ScheduleApi.update(id, payload)
      .then(({ data: schedule }) => {
        commit('updateSchedule', schedule)
        return schedule
      })
  },
  toggleEnabled ({ commit }, { id, isEnabled }: { id: number; isEnabled: boolean }) {
    commit('setScheduleEnabled', { id, isEnabled })
    return ScheduleApi.toggleEnabled(id, isEnabled)
      .then(({ data: schedule }) => {
        commit('updateSchedule', schedule)
        return schedule
      })
      .catch(error => {
        commit('setScheduleEnabled', { id, isEnabled: !isEnabled })
        throw error
      })
  },
  remove ({ commit }, id: number) {
    return ScheduleApi.remove(id)
      .then(() => {
        commit('removeSchedule', id)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any
